import { Component, OnInit, Input } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'cmat-seemore',
  templateUrl: './t_seemore.component.html',
  styleUrls: ['./seemore.component.css']
})
export class SeemoreComponent implements OnInit {

  toggleWord;

  @Input()
  content: string;

  @Input()
  max: number = 100;

  len: number;

  constructor(private translocoService:TranslocoService) { }

  ngOnInit() {
  	this.len = this.max;
    if(this.content == undefined) this.content = '';
  }

  ngAfterViewInit()
  {
    this.toggleWord = this.translocoService.translate( 'cmat-seemore-more');
  }

  toggleMax()
  {
  	if(this.len == this.max) {
  		this.len = this.content.length;
  		this.toggleWord = this.translocoService.translate( 'cmat-seemore-less');
  	} else {
  		this.len = this.max;
  		this.toggleWord = this.translocoService.translate( 'cmat-seemore-more');
  	}

  }

}
